import * as actionTypes from "../actions/types";

import uploadService from "../services/upload-files";
import axios from "axios";

export const actualizarAtriutoArchivos = (objeto) => (dispatch) => {
    dispatch({
        type: actionTypes.ACTUALIZAR_ATRIBUTOS_ARCHIVOS,
        payload: objeto,
    });
};

export const archivosSeleccionados = (
    archivos,
    fullPath,
    archivosHandler,
    archivosActuales,
    tempPath
) => (dispatch, getState) => {
    dispatch(sincronizarInformacionArchivos(archivosActuales));
    dispatch({ type: actionTypes.ARCHIVOS_SELECCIONADOS, payload: archivos });
    const archivosSeleccionados = getState().adjuntarArchivoReducer
        .selectedFiles;
    if (archivosSeleccionados.length > 0) {
        dispatch(subiendoArchivos(true));
        dispatch(
            subirArchivosSeleccionados(fullPath, archivosHandler, tempPath)
        );
    }
};

export const subirArchivosNuevaInternacion = (
    archivos,
    codPrestador,
    tempPath,
    internacion
) => (dispatch, getState) => {
    dispatch({
        type: actionTypes.SET_MOSTRAR_PROCESAR_INTERNACION,
        payload: true,
    });
    dispatch(cargaFinalizada(false));
    dispatch(sincronizarInformacionArchivos(internacion.detalles));
    dispatch({ type: actionTypes.ARCHIVOS_SELECCIONADOS, payload: archivos });
    const archivosSeleccionados = getState().adjuntarArchivoReducer
        .selectedFiles;
    if (archivosSeleccionados.length > 0) {
        dispatch(subiendoArchivos(true));
        dispatch(
            subirArchivosInternacionSeleccionados(
                codPrestador,
                tempPath,
                internacion
            )
        );
    }
};

export const cargaFinalizada = (finalizada) => (dispatch) => {
    dispatch(actualizarAtriutoArchivos({ cargaFinalizada: finalizada }));
};

export const sincronizarInformacionArchivos = (archivosActuales) => (
    dispatch
) => {
    dispatch({
        type: actionTypes.SINCRONIZAR_INFORMACION_ARCHIVOS,
        payload: archivosActuales,
    });
};

export const subiendoArchivos = (subiendo) => (dispatch) => {
    dispatch(
        actualizarAtriutoArchivos({ uploading: subiendo, cantRespuestas: 0 })
    );
};

export const eliminarArchivo = (
    pathArchivo,
    index,
    archivosHandler,
    archivosActuales
) => (dispatch, getState) => {
    dispatch(sincronizarInformacionArchivos(archivosActuales));

    uploadService.deleteFile(pathArchivo).then((response) => {
        dispatch({ type: actionTypes.ELIMINAR_ARCHIVO, payload: index });
        const informacionArchivos = getState().adjuntarArchivoReducer.fileInfos;
        archivosHandler(informacionArchivos);
    });
};

export const inicializarBarrasProceso = () => (dispatch) => {
    dispatch({ type: actionTypes.INICIALIZAR_BARRAS_PROCESO });
};

export const actualizarNuevaInternacion = (internacion) => (dispatch) => {
    dispatch({
        type: actionTypes.ACTUALIZAR_NUEVA_INTERNACION,
        payload: internacion,
    });
};

export const actualizarBarraProceso = (index, cargado, total) => (dispatch) => {
    dispatch({
        type: actionTypes.ACTUALIZAR_BARRA_PROCESO,
        payload: { index, cargado, total },
    });
};

export const actualizarInformacionArchivo = (archivo) => (dispatch) => {
    dispatch({
        type: actionTypes.ACTUALIZAR_INFORMACION_ARCHIVOS,
        payload: archivo,
    });
};

export const subirArchivosSeleccionados = (
    fullPath,
    archivosHandler,
    tempPath
) => (dispatch, getState) => {
    dispatch(inicializarBarrasProceso());
    const archivosSeleccionados = getState().adjuntarArchivoReducer
        .selectedFiles;

    const tokenCancelar = uploadService.generarTokenCancelacion();

    for (let i = 0; i < archivosSeleccionados.length; i++) {
        const archivo = archivosSeleccionados[i];
        dispatch(
            subirArchivo(
                archivo,
                fullPath,
                i,
                archivosHandler,
                tempPath,
                tokenCancelar
            )
        );
    }
};

export const reiniciarDatosInternacion = () => (dispatch) => {
    dispatch({ type: actionTypes.REINICIAR_DATOS_INTERNACION });
};

export const subiendoNuevaInternacion = (subiendo) => (dispatch) => {
    dispatch(actualizarAtriutoArchivos({ subiendoNuevaInternacion: subiendo }));
};

export const subirArchivosInternacionSeleccionados = (
    codPrestador,
    tempPath,
    internacion
) => (dispatch, getState) => {
    dispatch(inicializarBarrasProceso());

    const archivosSeleccionados = getState().adjuntarArchivoReducer
        .selectedFiles;

    const tokenCancelar = uploadService.generarTokenCancelacion();
    for (let i = 0; i < archivosSeleccionados.length; i++) {
        const archivo = archivosSeleccionados[i];

        dispatch(
            subirArchivoInternacion(
                codPrestador,
                tempPath,
                internacion,
                archivo,
                i,
                tokenCancelar
            )
        );
    }
};

export const agregarInternacion = (internacion) => (dispatch) => {
    dispatch({
        type: actionTypes.AGREGAR_INTERNACION,
        payload: internacion,
    });
};

export const actualizarInternacion = (internacion) => (dispatch) => {
    dispatch({
        type: actionTypes.ACTUALIZAR_INTERNACION,
        payload: internacion,
    });
};

export const subirArchivoInternacion = (
    codPrestador,
    tempPath,
    internacion,
    archivo,
    index,
    tokenCancelar
) => (dispatch, getState) => {
    const _archivo = procesarArchivoPorNombre(archivo);
    uploadService
        .uploadInternacion(
            archivo,
            codPrestador,
            tempPath,
            internacion,
            tokenCancelar,
            (event) => {
                dispatch(
                    actualizarBarraProceso(index, event.loaded, event.total)
                );
            }
        )
        .then((response) => {
            dispatch(sumarRespuestaRecibida());
            return response.data;
        })
        .then((respuesta) => {
            const archivo = respuesta.file;
            dispatch(actualizarInformacionArchivo(archivo));

            const archivosSeleccionados = getState().adjuntarArchivoReducer
                .selectedFiles;

            dispatch(evaluarFinalizarCargaInternacion(archivosSeleccionados));
        })
        .catch(function (thrown) {
            dispatch(sumarRespuestaRecibida());
            if (axios.isCancel(thrown)) {
                const subiendoInternacion = getState().adjuntarArchivoReducer
                    .subiendoNuevaInternacion;
                // Operacion cancelada
                dispatch(subiendoArchivos(false));
                dispatch({
                    type: actionTypes.SET_MOSTRAR_PROCESAR_INTERNACION,
                    payload: false,
                });
                if (!subiendoInternacion) {
                    dispatch({
                        type: actionTypes.RESET_INTERNACION_PARA_ACTUALIZAR,
                    });
                }
            } else {
                // handle error
                const archivosSeleccionados = getState().adjuntarArchivoReducer
                    .selectedFiles;

                const auxSeleccionados = archivosSeleccionados.filter(
                    (elemento) => elemento.name !== _archivo.name,
                    []
                );
                dispatch(evaluarFinalizarCargaInternacion(auxSeleccionados));
            }
        });
};

export const cancelarArchivosSeleccionados = () => (dispatch, getState) => {
    const archivosSubidos = [
        ...getState().adjuntarArchivoReducer.archivosSubidos,
    ];

    for (let i = 0; i < archivosSubidos.length; i++) {
        const archivo = archivosSubidos[i];
        uploadService.deleteFile(archivo.pathArchivo);
    }

    dispatch({
        type: actionTypes.VACIAR_ARCHIVOS_SUBIDOS,
    });
};

export const cancelarCargaMasiva = () => (dispatch, getState) => {
    const pathTemp = getState().nuevaPresentacionReducer.pathTemporal;
    dispatch(subiendoInternacionesMasivo(false));
    return uploadService.cancelarCargaMasiva(pathTemp);
};

const procesarArchivoPorNombre = (archivo) => {
    let file = archivo;

    if (archivo.name.length > 100) {
        const fragmentos = archivo.name.split(".");
        const i = fragmentos.length - 1;

        const extension = fragmentos[i];
        const nombre = archivo.name.substring(0, 90);
        const nombreArchivo = nombre + "." + extension;

        file = new File([archivo], nombreArchivo);
    }

    return file;
};

export const sumarRespuestaRecibida = () => (dispatch) => {
    dispatch({
        type: actionTypes.SUMAR_RESPUESTA,
    });
};

export const subirArchivo = (
    file,
    fullPath,
    index,
    archivosHandler,
    tempPath,
    tokenCancelar
) => (dispatch, getState) => {
    const archivo = procesarArchivoPorNombre(file);

    uploadService
        .upload(archivo, fullPath, tempPath, tokenCancelar, (event) => {
            dispatch(actualizarBarraProceso(index, event.loaded, event.total));
        })
        .then((response) => {
            dispatch(sumarRespuestaRecibida());
            const respuesta = response.data;
            const archivo = respuesta.file;
            dispatch(actualizarInformacionArchivo(archivo));

            const archivosSeleccionados = getState().adjuntarArchivoReducer
                .selectedFiles;

            dispatch(
                evaluarFinalizarCargaArchivos(
                    archivosSeleccionados,
                    archivosHandler
                )
            );

            if (respuesta.errors) {
                const errores = [...respuesta.errors];
                dispatch(procesarCargarErrores(errores, fullPath));
            }
        })
        .catch((error) => {
            dispatch(sumarRespuestaRecibida());
            if (axios.isCancel(error)) {
                // Operacion cancelada
                dispatch(subiendoArchivos(false));
            } else {
                // handle error
                const archivosSeleccionados = getState().adjuntarArchivoReducer
                    .selectedFiles;

                dispatch(
                    evaluarFinalizarCargaArchivos(
                        archivosSeleccionados,
                        archivosHandler
                    )
                );

                if (error.response) {
                    const errores = [...error.response.data.errors];
                    dispatch(procesarCargarErrores(errores, fullPath));
                }
            }
        });
};

const procesarCargarErrores = (errores, fullpath) => (dispatch) => {
    if (errores.length > 0 && fullpath.includes("prestaciones")) {
        dispatch(actualizarAtriutoArchivos({ erroresArchivos: errores }));
    }
};

const evaluarFinalizarCargaArchivos = (
    archivosSeleccionados,
    archivosHandler
) => (dispatch, getState) => {
    const archivosSubidos = getState().adjuntarArchivoReducer.archivosSubidos;
    const cantRespuestas = getState().adjuntarArchivoReducer.cantRespuestas;

    if (cantRespuestas === archivosSeleccionados.length) {
        const informacionArchivos = getState().adjuntarArchivoReducer.fileInfos;
        dispatch(subiendoArchivos(false));
        archivosHandler(informacionArchivos.concat(archivosSubidos));
    }
};

const evaluarFinalizarCargaInternacion = (archivosSeleccionados) => (
    dispatch,
    getState
) => {
    const cantRespuestas = getState().adjuntarArchivoReducer.cantRespuestas;

    if (cantRespuestas === archivosSeleccionados.length) {
        dispatch(cargaFinalizada(true));
    }
};

export const agregarArchivoNuevaInternacion = (archivo) => (dispatch) => {
    dispatch({
        type: actionTypes.AGREGAR_ARCHIVO_NUEVA_INTERNACION,
        payload: archivo,
    });
};

export const subirArchivosInternacionesMasivo = (archivos) => (
    dispatch,
    getState
) => {
    dispatch(cargaFinalizada(false));
    const tempPath = getState().nuevaPresentacionReducer.pathTemporal;
    dispatch(sincronizarInformacionArchivos([]));
    dispatch({ type: actionTypes.ARCHIVOS_SELECCIONADOS, payload: archivos });
    const archivosSeleccionados = getState().adjuntarArchivoReducer
        .selectedFiles;
    if (archivosSeleccionados.length > 0) {
        dispatch(subiendoArchivos(true));
        dispatch(subirArchivosSeleccionadosMasivo(tempPath));
    }
};

export const subirArchivosSeleccionadosMasivo = (tempPath) => (
    dispatch,
    getState
) => {
    dispatch(inicializarBarrasProceso());
    const archivosSeleccionados = getState().adjuntarArchivoReducer
        .selectedFiles;

    const tokenCancelar = uploadService.generarTokenCancelacion();
    for (let i = 0; i < archivosSeleccionados.length; i++) {
        const archivo = archivosSeleccionados[i];
        dispatch(
            subirArchivoInternacionesMasivo(tempPath, archivo, i, tokenCancelar)
        );
    }
};

export const subirArchivoInternacionesMasivo = (
    tempPath,
    archivo,
    index,
    tokenCancelar
) => (dispatch, getState) => {
    const _archivo = procesarArchivoPorNombre(archivo);
    uploadService
        .uploadInternaciones(_archivo, tempPath, tokenCancelar, (event) => {
            dispatch(actualizarBarraProceso(index, event.loaded, event.total));
        })
        .then((response) => {
            dispatch(sumarRespuestaRecibida());
            return response.data;
        })
        .then((respuesta) => {
            const archivo = respuesta.file;
            dispatch(actualizarInformacionArchivo(archivo));

            const archivosSeleccionados = getState().adjuntarArchivoReducer
                .selectedFiles;
            dispatch(evaluarFinalizarCargaInternacion(archivosSeleccionados));
        })
        .catch(function (thrown) {
            dispatch(sumarRespuestaRecibida());
            if (axios.isCancel(thrown)) {
                // Operacion cancelada
                dispatch(subiendoArchivos(false));
            } else {
                // handle error
                const archivosSeleccionados = getState().adjuntarArchivoReducer
                    .selectedFiles;

                dispatch(
                    evaluarFinalizarCargaInternacion(archivosSeleccionados)
                );
            }
        });
};

export const subiendoInternacionesMasivo = (subiendo) => (dispatch) => {
    dispatch(
        actualizarAtriutoArchivos({ subiendoInternacionesMasivo: subiendo })
    );
};
